import React from "react";
import bgHomeS3 from "../../assets/landingPage/bg-home-s3.png";
import soulflowRecordImg from "../../assets/landingPage/soulflow-record.png";

export default function SoulFlowSectionNew() {
  return (
    <section
      id="soulflow"
      className="w-full py-20 px-4 md:px-8 lg:px-16  bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgHomeS3})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 pointer-events-none"></div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Left Side: Text Info */}
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-oswald text-secondary tracking-wide uppercase mb-3">
            B.A.B SOULFLOW RECORDS
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold font-oswald text-white tracking-widest uppercase mb-6">
            A COMPLETE RECORD COMPANY
          </h3>
          <p className="text-gray-300 font-outfit text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            AJB's SoulFlow Records is the official music powerhouse of BAB Media. The label delivers original albums, singles, soundtracks, and exclusive artist releases - all available for streaming, download, and purchase directly on the platform.
          </p>
        </div>

        {/* Right Side: Circular Gold Emblem */}
        <div className="w-full md:w-1/2 max-w-md flex justify-center">
          <div className="relative group p-1.5 rounded overflow-hidden hover:scale-105 transition-transform duration-500 shadow-2xl">
            <img
              src={soulflowRecordImg}
              alt="B.A.B SoulFlow Records By AJB Logo"
              className="object-cover rounded h-[280px] w-[280px] md:h-[450px] md:w-[450px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
